package com.patronat.top.client.domain.venues

import com.patronat.top.client.data.venues.ClientVenuesRepository
import com.patronat.top.core.dispatchers.DispatcherProvider
import com.patronat.top.core.domain.models.DomainResult
import com.patronat.top.domain.usecase.BaseUseCase
import com.patronat.top.dto.SavedVenueIdsResponse
import com.patronat.top.dto.VenueListResponse

data class GetClientSavedVenuesCommand(
    val page: Int = 1,
    val pageSize: Int = 20,
    val query: String? = null
)

data class ToggleClientSavedVenueCommand(
    val venueId: String,
    val isSaved: Boolean
)

class GetClientSavedVenueIdsUseCase(
    private val repository: ClientVenuesRepository,
    dispatcherProvider: DispatcherProvider
) : BaseUseCase<Unit, DomainResult<SavedVenueIdsResponse>>(
    dispatcher = dispatcherProvider.io
) {
    override suspend fun doWork(command: Unit): DomainResult<SavedVenueIdsResponse> {
        return repository.getSavedVenueIds()
    }
}

class GetClientSavedVenuesUseCase(
    private val repository: ClientVenuesRepository,
    dispatcherProvider: DispatcherProvider
) : BaseUseCase<GetClientSavedVenuesCommand, DomainResult<VenueListResponse>>(
    dispatcher = dispatcherProvider.io
) {
    override suspend fun doWork(command: GetClientSavedVenuesCommand): DomainResult<VenueListResponse> {
        return repository.getSavedVenues(
            page = command.page,
            pageSize = command.pageSize,
            query = command.query
        )
    }
}

class ToggleClientSavedVenueUseCase(
    private val repository: ClientVenuesRepository,
    dispatcherProvider: DispatcherProvider
) : BaseUseCase<ToggleClientSavedVenueCommand, DomainResult<Unit>>(
    dispatcher = dispatcherProvider.io
) {
    override suspend fun doWork(command: ToggleClientSavedVenueCommand): DomainResult<Unit> {
        return if (command.isSaved) {
            repository.unsaveVenue(command.venueId)
        } else {
            repository.saveVenue(command.venueId)
        }
    }
}

class UnsaveClientVenueUseCase(
    private val repository: ClientVenuesRepository,
    dispatcherProvider: DispatcherProvider
) : BaseUseCase<String, DomainResult<Unit>>(
    dispatcher = dispatcherProvider.io
) {
    override suspend fun doWork(command: String): DomainResult<Unit> {
        return repository.unsaveVenue(command)
    }
}
